import './App.css';
import { Route, Routes } from 'react-router-dom';
import Index from './pages/index';
import IndexAgency from './pages/demo/index-agency';
import IndexSoftware from './pages/demo/index-software';
import IndexStartup from './pages/demo/index-startup';
import IndexApplication from './pages/demo/index-application';
import IndexGym from './pages/demo/index-gym';
import IndexBusiness from './pages/demo/index-business';
import IndexFinance from './pages/demo/index-finance';
import IndexCorporate from './pages/demo/index-corporate';
import IndexMarketing from './pages/demo/index-marketing';
import IndexEventManagment from './pages/demo/index-event-managment';
import IndexFreelancer from './pages/demo/index-freelancer';
import IndexPortfolio from './pages/demo/index-portfolio';
import IndexStudio from './pages/demo/index-studio';
import IndexLawyer from './pages/demo/index-lawyer';
import IndexContraction from './pages/demo/index-contraction';
import IndexAnalytics from './pages/demo/index-analytics';
import IndexCoworking from './pages/demo/index-coworking';
import IndexHosting from './pages/demo/index-hosting';
import IndexCryptocurrency from './pages/demo/index-cryptocurrency';
import IndexHealth from './pages/demo/index-health';
import IndexCareer from './pages/demo/index-career';
import IndexItSolution from './pages/demo/index-it-solution';
import IndexProperty from './pages/demo/index-property';
import IndexPoc from './pages/demo/index-poc';
import IndexRootsAndWings from './pages/demo/index-roots-and-wings';
import IndexBridgeToBharath from './pages/demo/index-bridge-to-bharath';
import PagePodcasts from './pages/page-podcasts';
import IndexEducation from './pages/demo/index-education';
import IndexCharity from './pages/demo/index-charity';
import PageAbout from './pages/page-about';
import PageProfile from './pages/page-profile';
import PageServices from './pages/page-services';
import PagePricing from './pages/page-pricing';
import PageTeam from './pages/page-team';
import PageJobs from './pages/jobs/page-jobs';
import PageJobDetail from './pages/jobs/page-job-detail';
import PageJobApplyForm from './pages/jobs/page-job-apply-form';
import HelpOverview from './pages/help-center/help-overview';
import HelpFaq from './pages/help-center/help-faq';
import HelpSupport from './pages/help-center/help-support';
import HelpGuides from './pages/help-center/help-guides';
import PageCases from './pages/cases/page-cases';
import PageCaseSingle from './pages/cases/page-case-single';
import PageServiceSingle from './pages/cases/page-service-single';
import PageAILabs from './pages/cases/page-ai-lab';
import PagePodcastPreview from './pages/cases/page-podcast-preview';
import PageIndiaEvaluation  from './pages/page-india-evaluation';
import PageIndiaEntry  from './pages/page-india-entry';
import PageIndiaGrowth  from './pages/page-india-growth';
import PageTerm from './pages/utility/page-term';
import PagePrivacy from './pages/utility/page-privacy';
import PageWhyIndia from './pages/page-why-india'
import PageThankYou from './pages/page-thankyou'
import Components from './pages/components';
import PortfolioClassicTwo from './pages/portfolio/portfolio-classic-two';
import PortfolioClassicThree from './pages/portfolio/portfolio-classic-three';
import PortfolioClassicFour from './pages/portfolio/portfolio-classic-four';
import PortfolioClassicFive from './pages/portfolio/portfolio-classic-five';
import PortfolioClassicSix from './pages/portfolio/portfolio-classic-six';
import PortfolioCreativeTwo from './pages/portfolio/portfolio-creative-two';
import PortfolioCreativeThree from './pages/portfolio/portfolio-creative-three';
import PortfolioCreativeFour from './pages/portfolio/portfolio-creative-four';
import PortfolioCreativeFive from './pages/portfolio/portfolio-creative-five';
import PortfolioCreativeSix from './pages/portfolio/portfolio-creative-six';
import PortfolioModernTwo from './pages/portfolio/portfolio-modern-two';
import PortfolioModernThree from './pages/portfolio/portfolio-modern-three';
import PortfolioModernFour from './pages/portfolio/portfolio-modern-four';
import PortfolioModernFive from './pages/portfolio/portfolio-modern-five';
import PortfolioModernSix from './pages/portfolio/portfolio-modern-six';
import PortfolioMasonryTwo from './pages/portfolio/portfolio-masonry-two';
import PortfolioMasonryThree from './pages/portfolio/portfolio-masonry-three';
import PortfolioMasonryFour from './pages/portfolio/portfolio-masonry-four';
import PortfolioMasonryFive from './pages/portfolio/portfolio-masonry-five';
import PortfolioMasonrySix from './pages/portfolio/portfolio-masonry-six';
import PortfolioDetailOne from './pages/portfolio/portfolio-detail-one';
import PortfolioDetailTwo from './pages/portfolio/portfolio-detail-two';
import PortfolioDetailThree from './pages/portfolio/portfolio-detail-three';
import Blogs from './pages/blog/blogs';
import BlogsSidebar from './pages/blog/blogs-sidebar';
import BlogStandardPost from './pages/blog/blog-standard-post';
import BlogGalleryPost from './pages/blog/blog-gallery-post';
import BlogSliderPost from './pages/blog/blog-slider-post';
import BlogLinkPost from './pages/blog/blog-link-post';
import BlogStoryPost from './pages/blog/blog-story-post';
import BlogYoutubePost from './pages/blog/blog-youtube-post';
import BlogHtmlVideoPost from './pages/blog/blog-html-video-post';
import BlogAudioPost from './pages/blog/blog-audio-post';
import BlogHtmlAudio from './pages/blog/blog-html-audio';
import BlogBlockquotePost from './pages/blog/blog-blockquote-post';
import BlogVimeoPost from './pages/blog/blog-vimeo-post';
import BlogLeftSidebarPost from './pages/blog/blog-left-sidebar-post';
import Contact from './pages/contact';
import Bridge from './pages/bridge';
import PageLogin from './pages/authentication/page-login';
import PageSignup from './pages/authentication/page-signup';
import PageForgotPassword from './pages/authentication/page-forgot-password';
import PageLogin2 from './pages/authentication/page-login-2';
import PageSignup2 from './pages/authentication/page-signup-2';
import PageForgotPassword2 from './pages/authentication/page-forgot-password-2';
import PageComingsoon from './pages/special/page-comingsoon';
import PageMaintenance from './pages/special/page-maintenance';
import Page404 from './pages/special/page-404';


function MainContent() {
  return (
    <Routes>
      <Route path='/' element={<IndexPoc/>} />
      <Route path='/index-agency' element={<IndexAgency/>} />
      <Route path='/index-software' element={<IndexSoftware/>} />
      <Route path='/index-startup' element={<IndexStartup/>} />
      <Route path='/index-application' element={<IndexApplication/>} />
      <Route path='/index-gym' element={<IndexGym/>} />
      <Route path='/index-business' element={<IndexBusiness/>} />
      <Route path='/index-finance' element={<IndexFinance/>} />
      <Route path='/index-corporate' element={<IndexCorporate/>} />
      <Route path='/index-marketing' element={<IndexMarketing/>} />
      <Route path='/index-event-managment' element={<IndexEventManagment/>} />
      <Route path='/index-freelancer' element={<IndexFreelancer/>} />
      <Route path='/index-portfolio' element={<IndexPortfolio/>} />
      <Route path='/index-studio' element={<IndexStudio/>} />
      <Route path='/index-lawyer' element={<IndexLawyer/>} />
      <Route path='/index-lawyer' element={<IndexLawyer/>} />
      <Route path='/index-contraction' element={<IndexContraction/>} />
      <Route path='/index-analytics' element={<IndexAnalytics/>} />
      <Route path='/index-coworking' element={<IndexCoworking/>} />
      <Route path='/index-hosting' element={<IndexHosting/>} />
      <Route path='/index-cryptocurrency' element={<IndexCryptocurrency/>} />
      <Route path='/index-health' element={<IndexHealth/>} />
      <Route path='/index-career' element={<IndexCareer/>} />
      <Route path='/index-it-solution' element={<IndexItSolution/>} />
      <Route path='/index-property' element={<IndexProperty/>} />
      <Route path='/index-poc' element={<IndexPoc/>} />
     <Route path='/index-education' element={<IndexEducation/>} />
      <Route path='/index-charity' element={<IndexCharity/>} />

      <Route path='/page-about' element={<PageAbout/>} />
      <Route path='/podcasts' element={<PagePodcasts/>} />
      <Route path='/page-profile' element={<PageProfile/>} />
      <Route path='/page-services' element={<PageServices/>} />
      <Route path='/page-pricing' element={<PagePricing/>} />
      <Route path='/page-team' element={<PageTeam/>} />
      <Route path='/page-jobs' element={<PageJobs/>} />
      <Route path='/page-job-detail' element={<PageJobDetail/>} />
      <Route path='/page-job-detail/:id' element={<PageJobDetail/>} />
      <Route path='/page-job-apply-form' element={<PageJobApplyForm/>} />
      <Route path='/help-overview' element={<HelpOverview/>} />
      <Route path='/help-faq' element={<HelpFaq/>} />
      <Route path='/help-support' element={<HelpSupport/>} />
      <Route path='/help-guides' element={<HelpGuides/>} />
      <Route path='/page-cases' element={<PageCases/>} />
      <Route path='/page-case-single/:id' element={<PageCaseSingle/>} />
      <Route path='/page-service-single/:id' element={<PageServiceSingle/>} />
      <Route path='/page-ai-lab' element={<PageAILabs/>} />
      <Route path='/page-podcast-preview' element={<PagePodcastPreview/>} />
      <Route path='/podcast' element={<IndexRootsAndWings/>} />
      <Route path='/rootsandwings' element={<IndexRootsAndWings/>} />
      <Route path='/podcasts/roots-and-wings' element={<IndexRootsAndWings/>} />
      <Route path='/bridgetobharath' element={<IndexBridgeToBharath/>} />
      <Route path='/bridge-to-bharath' element={<IndexBridgeToBharath/>} />
      <Route path='/podcasts/bridge-to-bharath' element={<IndexBridgeToBharath/>} />
      <Route path='/page-t&c' element={<PageTerm/>} />
      <Route path='/page-privacy' element={<PagePrivacy/>} />
      <Route path='/page-why-india' element={<PageWhyIndia/>} />
      <Route path='/page-india-evaluation' element={<PageIndiaEvaluation/>} />
      <Route path='/page-india-entry' element={<PageIndiaEntry/>} />
      <Route path='/page-india-growth' element={<PageIndiaGrowth/>} />
      <Route path='/components' element={<Components/>} />

      <Route path='/portfolio-classic-two' element={<PortfolioClassicTwo/>} />
      <Route path='/portfolio-classic-three' element={<PortfolioClassicThree/>} />
      <Route path='/portfolio-classic-four' element={<PortfolioClassicFour/>} />
      <Route path='/portfolio-classic-five' element={<PortfolioClassicFive/>} />
      <Route path='/portfolio-classic-six' element={<PortfolioClassicSix/>} />
      <Route path='/portfolio-creative-two' element={<PortfolioCreativeTwo/>} />
      <Route path='/portfolio-creative-three' element={<PortfolioCreativeThree/>} />
      <Route path='/portfolio-creative-four' element={<PortfolioCreativeFour/>} />
      <Route path='/portfolio-creative-five' element={<PortfolioCreativeFive/>} />
      <Route path='/portfolio-creative-six' element={<PortfolioCreativeSix/>} />
      <Route path='/portfolio-modern-two' element={<PortfolioModernTwo/>} />
      <Route path='/portfolio-modern-three' element={<PortfolioModernThree/>} />
      <Route path='/portfolio-modern-Four' element={<PortfolioModernFour/>} />
      <Route path='/portfolio-modern-Five' element={<PortfolioModernFive/>} />
      <Route path='/portfolio-modern-Six' element={<PortfolioModernSix/>} />
      <Route path='/portfolio-masonry-two' element={<PortfolioMasonryTwo/>} />
      <Route path='/portfolio-masonry-three' element={<PortfolioMasonryThree/>} />
      <Route path='/portfolio-masonry-Four' element={<PortfolioMasonryFour/>} />
      <Route path='/portfolio-masonry-Five' element={<PortfolioMasonryFive/>} />
      <Route path='/portfolio-masonry-six' element={<PortfolioMasonrySix/>} />
      <Route path='/portfolio-detail-one' element={<PortfolioDetailOne/>} />
      <Route path='/portfolio-detail-one/:id' element={<PortfolioDetailOne/>} />
      <Route path='/portfolio-detail-two' element={<PortfolioDetailTwo/>} />
      <Route path='/portfolio-detail-two/:id' element={<PortfolioDetailTwo/>} />
      <Route path='/portfolio-detail-three' element={<PortfolioDetailThree/>} />
      <Route path='/portfolio-detail-three/:id' element={<PortfolioDetailThree/>} />

      <Route path='/blogs' element={<Blogs/>} />
      <Route path='/blogs-sidebar' element={<BlogsSidebar/>} />
      <Route path='/blog-standard-post' element={<BlogStandardPost/>} />
      <Route path='/blog-standard-post/:id' element={<BlogStandardPost/>} />
      <Route path='/blog-gallery-post' element={<BlogGalleryPost/>} />
      <Route path='/blog-slider-post' element={<BlogSliderPost/>} />
      <Route path='/blog-link-post' element={<BlogLinkPost/>} />
      <Route path='/blog-story-post' element={<BlogStoryPost/>} />
      <Route path='/blog-youtube-post' element={<BlogYoutubePost/>} />
      <Route path='/blog-html-video-post' element={<BlogHtmlVideoPost/>} />
      <Route path='/blog-audio-post' element={<BlogAudioPost/>} />
      <Route path='/blog-html-audio' element={<BlogHtmlAudio/>} />
      <Route path='/blog-blockquote-post' element={<BlogBlockquotePost/>} />
      <Route path='/blog-vimeo-post' element={<BlogVimeoPost/>} />
      <Route path='/blog-left-sidebar-post' element={<BlogLeftSidebarPost/>} />
      <Route path='/contact' element={<Contact/>} />
      {/* <Route path='/bridge' element={<Bridge/>} /> */}
      <Route path='/b2b-exec-summary' element={<Bridge/>} />
      <Route path='/page-login' element={<PageLogin/>} />
      <Route path='/page-signup' element={<PageSignup/>} />
      <Route path='/page-forgot-password' element={<PageForgotPassword/>} />
      <Route path='/page-login-2' element={<PageLogin2/>} />
      <Route path='/page-signup-2' element={<PageSignup2/>} />
      <Route path='/page-forgot-password-2' element={<PageForgotPassword2/>} />
      <Route path='/page-comingsoon' element={<PageComingsoon/>} />
      <Route path='/page-thankyou' element={<PageThankYou/>} />
      <Route path='/page-maintenance' element={<PageMaintenance/>} />
      <Route path='/page-404' element={<Page404/>} />
      <Route path='/*' element={<Page404/>} />

    </Routes>
    
  );
}

export default MainContent;
